import React from 'react';
import './style.scss';

export const Checkbox = ({ children, className, name, ...props }) => (
  <div className={`checkbox-default ${className}`}>
    <input id={name} type="checkbox" name={name} {...props} />
    <label htmlFor={name}>{children}</label>
  </div>
);
